<template>
	<ValidationObserver ref="form" v-slot="{ invalid }">
		<div class="con-1334 box-white mt-30px">
			<component :is="thisComponent" ref="dataComponent" />
		</div>
		<div class="con-1334 navBtn">
			<a class="navBtn-prev" @click="handlePrev">Vissza</a>
			<LoadingButton text="Tovább" class="navBtn-next btn btn-blue" @click="handleNext" />
		</div>
		<div class="con-1334 just-mobile" v-if="invalid && hasError">
			<span class="error_message justify-center">Hiányos adat kitöltés</span>
		</div>
	</ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';
import contractingRouter from '@/mixins/contractingRouter';
import dataViewRouting from '@/mixins/dataViewRouting';
import GranitInsuredData from '@/pages/Contracting/Granit/InsuredData';
import ColonnadeInsuredData from './Colonnade/InsuredData';
import KobeInsuredData from './Kobe/InsuredData';
import UnionInsuredData from './Union/InsuredData';
import AllianzInsuredData from './Allianz/InsuredData';
import GeneraliInsuredData from './Generali/InsuredData';
import AlfaInsuredData from './Alfa/InsuredData';
import LoadingButton from '@/components/elements/LoadingButton';

export default {
	mixins: [contractingRouter, dataViewRouting],
	components: {
		LoadingButton,
        GranitInsuredData,
		ColonnadeInsuredData,
		KobeInsuredData,
		UnionInsuredData,
		AllianzInsuredData,
		GeneraliInsuredData,
        AlfaInsuredData,
	},
	computed: {
		...mapGetters('contracting', ['getSelectedInsurerCode', 'getInsurerCodes']),
		thisComponent() {
			if (this.getSelectedInsurerCode !== null) {
				return `${this.getInsurerCodes[this.getSelectedInsurerCode]}InsuredData`;
			}

			return null;
		},
	},
};
</script>

<style lang="scss" scoped>
.con-1334 {
	padding-left: 0;
	padding-right: 0;
}
</style>
